import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import cx from "classnames";
import { Switch, Route, Redirect, Router, useHistory } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "beaktShared/components/Navbars/AdminNavbar.js";
import Footer from "beaktShared/components/Footer/Footer.js";
import Sidebar from "beaktShared/components/Sidebar/Sidebar.js";
import routes_before from "beaktClinic/routesclinic";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { getTokenCookie } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { Chat } from "beaktShared/constants/Chat";
import ComunicadoBlockOverlay from "beaktShared/components/Comunicado/ComunicadoBlockOverlay";
var ps;

const useStyles = makeStyles(styles);

export default function Admin(props) {
  const history = useHistory();
  const { t } = useTranslation();

  const [session] = useState(getSessionCookie());
  const [routes, setroutes] = React.useState([]);
  // Comunicados pendentes de aceite do usuario logado, informados pelo ComunicadoBlockOverlay (badge do menu)
  const [totalComunicadosPendentes, setTotalComunicadosPendentes] = useState(0);

  useEffect(() => {
    Chat();
    if (validateToken("") === true)
      getRoutesApi();

  }, []);

  useEffect(() => {
    setInterval(() => {
      var token = getTokenCookie();
      if (token === null) {
        props.history.push("/auth/login");
        return false;
      }
    }, 3000);

    validateToken(history.location.pathname);
  }, [history.location.pathname]);

  const validateToken = (activeRoute) => {
    if (session != null && !(session.tipoPerfil == 0 || session.tipoPerfil == 1 || session.tipoPerfil == 2 || (session.tipoPerfil == 4 && session.acessaTodosEstabelecimentos == true))) {
      props.history.push("/auth/login");
      return false;
    }

    var token = getTokenCookie();

    if (session === null || token === null) {
      props.history.push("/auth/login");
      return false;
    }

    if (token.expired)
      props.history.push("/auth/login");

    if (activeRoute != "" && activeRoute != "/adminclinic/home" && activeRoute != "/adminclinic/accessdenied" && activeRoute != "/auth/login") {
      if (session.tipoPerfil != 0 && session.tipoPerfil != 4) {

        activeRoute = verifyPathFather(activeRoute);

        UseGetApiSimple("usuarios/checkpermission/" + session.estabelecimentoId + "/" + session.id + "/" + activeRoute).then(result => {
          if (result.data != true)
            props.history.push("/adminclinic/accessdenied");
        })
      }
    }
    return true;
  }

  const verifyPathFather = (activeRoute) => {
    activeRoute = activeRoute.replace("/adminclinic/", "");

    let pathfiltered = routes_before.filter((prop) => {
      return ((prop.collapse == null && ("/" + activeRoute) === prop.path)
        || (prop.collapse == true && prop.views.filter((f) => f.path == ("/" + activeRoute)).length > 0)
      )
    });

    if (pathfiltered[0]) {
      if (pathfiltered[0].pathFather)
        activeRoute = pathfiltered[0].pathFather.replace("/", "");
    }

    return activeRoute;
  }

  const getRoutesApi = () => {
    let routes_menu = routes_before;
    if (session.estabelecimentoFranqueado === false) {
      let route_estoque = routes_menu.filter(f => f.name === "stock")[0];
      route_estoque.views = route_estoque.views.filter(f => (f.path != "/pedidocompra" && f.path != "/gestaopedidocompra"));
      routes_menu = routes_menu.map((m) => m.name === "stock" ? route_estoque : m);
    }
    
    if (session.tipoPerfil == 0 || session.tipoPerfil == 4) {
      setroutes(routes_menu);
    }
    else {
      UseGetApiSimple("usuarios/getpermissoes/" + session.estabelecimentoId + "/" + session.id, "").then(result => {
        updateRoutes(routes_menu, result.data);
      });
    }

    // Validação do campo UtilizaCSJPIX da Franquia para exibir menu de configuração
    if (session.utilizaCSJPix)
    {
      // Ajuste solicitado pelo Andre, liberar apenas para perfil MATRIZ (173773)
      if (session.tipoPerfil == 0 || session.tipoPerfil == 4) 
      {
        routes_menu = routes_menu.map(route => {
          if (route.views) {
            route.views = route.views.map(view => {
              if (view.path === "/cadastroChavePIX") {
                return { ...view, showmenu: true };
              }
              return view;
            });
          } else if (route.path === "/cadastroChavePIX") {
            return { ...route, showmenu: true };
          }
          return route;
        });
      }
    }

  }

  const updateRoutes = (listroutes, permissions) => {
    let listfiltered = listroutes.filter((prop) => {
      return ((prop.collapse == null && permissions.filter((p) => ("/" + p.path) === prop.path).length > 0)
        || (prop.collapse == true && permissions.filter((p) => prop.views.filter((f) => f.path == ("/" + p.path)).length > 0).length > 0)
        || (prop.pathFather)
        || (prop.path === "/accessdenied")
        || (prop.path === "/home")
      )
    });
    setroutes(listfiltered);
  };

  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  // const [image] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color] = React.useState("blue");
  const [bgColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  const [logo, set_logo] = React.useState("");
  useEffect(() => {
    if (session != null)
      set_logo(process.env.REACT_APP_API_ENDPOINT + "anexos/" + session.logoPequeno);
  }, [session]);
  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });

  const sendScrollToTOP = () => {
    const container = document.querySelector('#divscroll');
    container.scrollTop = 0;
  }

  // functions for changeing the states from components
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getActiveRoute = routes => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      return (
        <Route
          path={prop.layout + prop.path}
          render={(props) => (<prop.component callUpdateScrollTOP={sendScrollToTOP} history={props.history} />)}
          key={key}
        />
      );
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <SessionContext.Provider value={session}>
        {/* Bloqueio global enquanto houver comunicado pendente de aceite (BKT-1545) */}
        {session && <ComunicadoBlockOverlay history={props.history} onPendentesChange={setTotalComunicadosPendentes} />}

        <div className={classes.wrapper}>
          <Sidebar
            history={props.history}
            routes={routes}
            badges={{ "/mural": totalComunicadosPendentes }}
            logoText={"Clinica"}
            logo={logo}
            redirectlogo={"/adminclinic/home"}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color={color}
            bgColor={bgColor}
            miniActive={miniActive}
            session={session}
            pathMainUrl="adminclinic"
            {...rest}
          />
          <div className={mainPanelClasses} ref={mainPanel} id="divscroll">
            <AdminNavbar
              sidebarMinimize={sidebarMinimize.bind(this)}
              miniActive={miniActive}
              brandText={getActiveRoute(routes) === "" ? "" : t('sidebar.' + getActiveRoute(routes))}
              handleDrawerToggle={handleDrawerToggle}
              history={props.history}
              pathMainUrl="adminclinic"
              {...rest}
            />

            <div className={classes.content}>
              <div className={classes.container + " allowPrint"}>
                <Switch>
                  {getRoutes(routes)}
                  {/* Comentei esse codigo, pois sempre que aperta o f5 encaminhava pra home.. ao inves de atualizar a tela atual
                  <Redirect from="/adminclinic" to="/adminclinic/home" />*/}
                </Switch>
              </div>
            </div>

            <Footer fluid />
          </div>
        </div>
      </SessionContext.Provider>

    </>

  );
}
